const SidebarFooter = () => {
    return(
        <div className="sidebar-footer">
            <div>Versão 1.0.1</div>
            <div>© Smart Olfativos</div>
        </div>
    )
}

export default SidebarFooter;